import { configureStore } from "@reduxjs/toolkit";
import cachedPlayerListsReducer from "./cachedPlayerLists/cachedPlayerListsSlice";
import { comparePlayersReducer } from "./comparePlayers/comparePlayerSlice";
import evolutionsReducer from "./evolutions/evolutionsSlice";
import { evolvedPlayersReducer } from "./evolutions/evolvedPlayersSlice";
import filtersReducer from "./filters/filtersSlice";
import frontPageFeedsReducer from "./frontPage/frontPageFeedsSlice";
import loadedContentReducer from "./loadedContent/loadedContentSlice";
import messageReducer from "./message/messageSlice";
import myClubReducer from "./myClub/myClubSlice";
import myPlayersReducer from "./myClub/myPlayersSlice";
import permissionsReducer from "./permissions/permissionsSlice";
import playerReducer from "./players/playerSlice";
import playersReducer from "./players/playersSlice";
import sbcSetsReducer from "./sbcs/sbcSetsSlice";
import streamlineReducer from "./streamline/streamlineSlice";
import userReducer from "./users/userSlice";
export const store = configureStore({
    reducer: {
        userReducer,
        playersReducer,
        playerReducer,
        loadedContentReducer,
        messageReducer,
        sbcSetsReducer,
        myClubReducer,
        myPlayersReducer,
        comparePlayersReducer,
        evolutionsReducer,
        evolvedPlayersReducer,
        filtersReducer,
        cachedPlayerListsReducer,
        frontPageFeedsReducer,
        permissionsReducer,
        streamlineReducer,
    },
    middleware: (getDefaultMiddleware) => 
    /*
    Right now, I am putting a JSX element in the store when dispatching a message.
    It gives a warning because it isn't serializible. It is a bit of an anti-pattern
    but it doesn't do anything bad except debugging this particular JSX component is a bit harder
    in a Redux context.
    */
    getDefaultMiddleware({ serializableCheck: false }),
    preloadedState: {},
});
// export default store;
//# sourceMappingURL=store.js.map